import Layout from "../components/layout/LandingPageLayout";
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardContent,
  CardMedia,
  useTheme,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import {Link}  from "react-router-dom";

const CloudStorageInfo = () => {
  const theme = useTheme();

  const features = [
    {
      title: "Secure Uploads",
      description:
        "Upload and store all your financial files safely on the cloud with enterprise-grade security.",
      icon: <CloudUploadIcon sx={{ fontSize: 50, color: theme.palette.primary.main }} />,
      image:
        "https://cdn-icons-png.flaticon.com/512/2921/2921222.png", // dummy illustration
    },
    {
      title: "Instant Preview",
      description:
        "Preview documents directly in your browser without downloading — fast and easy.",
      icon: <VisibilityIcon sx={{ fontSize: 50, color: theme.palette.success.main }} />,
      image:
        "https://cdn-icons-png.flaticon.com/512/2991/2991148.png", // dummy illustration
    },
    {
      title: "Quick Downloads",
      description:
        "Download your files anytime, anywhere. Access your data with just one click.",
      icon: <DownloadIcon sx={{ fontSize: 50, color: theme.palette.info.main }} />,
      image:
        "https://cdn-icons-png.flaticon.com/512/724/724933.png", // dummy illustration
    },
  ];

  return (
    <Layout>
      <Box
        sx={{
          py: 8,
          px: 3,
          textAlign: "center",
          background: theme.palette.background.default,
        }}
      >
        {/* Heading */}
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          Cloud Storage for Your Financial Data
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ maxWidth: "700px", mx: "auto", mb: 6 }}
        >
          Store, preview, and download your financial files anytime. Secure,
          reliable, and built for professionals like you.
        </Typography>

        {/* Features Grid */}
        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 3,
                  height: "100%",
                  transition: "0.3s",
                  "&:hover": { transform: "translateY(-5px)", boxShadow: 6 },
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  {feature.icon}
                  <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mb={2}>
                    {feature.description}
                  </Typography>
                </CardContent>
                <CardMedia
                  component="img"
                  alt={feature.title}
                  image={feature.image}
                  sx={{
                    height: 150,
                    objectFit: "contain",
                    p: 2,
                  }}
                />
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* CTA */}
        <Box mt={8}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Ready to organize your financial files?
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            Upload, preview, and download your reports in one secure place.
          </Typography>
          <Button
            component={Link}
            to="/signup"
            variant="contained"
            size="large"
            sx={{
              borderRadius: "30px",
              px: 5,
              py: 1.8,
              fontSize: "1rem",
              textTransform: "none",
              boxShadow: 4,
            }}
          >
            Start Using Cloud Storage
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default CloudStorageInfo;
